module.exports = __webpack_public_path__ + "img/manoj.ae7a82a9.jpg";